import { CMSResource } from 'app/resources/cmsresource';
import { WelcomeAndKioskResource } from './WelcomeAndKioskResource';
export class WelcomeResource extends CMSResource {
	rid: string;
	titleRo: string;
	titleFr: string;
	titleEn: string;
	titleDe: string;
	descriptionRo: string;
	descriptionEn: string;
	descriptionFr: string;
	descriptionDe: string;
	image: string;
	imageString: string;
	userEmail: string;
	kioskResourceList: WelcomeAndKioskResource[];

	showDelete: boolean = false;
}